/**
 * フッターナビ SP アコーディオン
 * .js-footer-nav-btn: jQuery slideDown / slideUp（PC では常時表示・クリック無効）
 */
import $ from 'jquery';

const MQ_SP = '(max-width: 767px)';

function syncFooterNavLayout() {
	const sp = window.matchMedia(MQ_SP).matches;
	const $groups = $('.js-footer-nav-group');
	$groups.find('.l-footer__navList').stop(true, true);
	if (!sp) {
		$groups.find('.l-footer__navList').removeAttr('style');
		$groups.addClass('is-open');
		$groups.find('.js-footer-nav-btn').attr('aria-expanded', 'true');
	} else {
		$groups.removeClass('is-open');
		$groups.find('.js-footer-nav-btn').attr('aria-expanded', 'false');
		$groups.find('.l-footer__navList').hide();
	}
}

export function init() {
	const $groups = $('.js-footer-nav-group');
	if (!$groups.length) return;

	syncFooterNavLayout();
	window.matchMedia(MQ_SP).addEventListener('change', syncFooterNavLayout);

	$groups.each(function () {
		const $group = $(this);
		const $btn = $group.find('.js-footer-nav-btn');
		const $list = $group.find('.l-footer__navList');
		if (!$btn.length || !$list.length) return;

		$btn.on('click', function () {
			if (!window.matchMedia(MQ_SP).matches) return;

			const wasOpen = $group.hasClass('is-open');

			$groups.not($group).each(function () {
				const $g = $(this);
				$g.removeClass('is-open');
				$g.find('.js-footer-nav-btn').attr('aria-expanded', 'false');
				$g.find('.l-footer__navList').stop(true, false).slideUp();
			});

			if (wasOpen) {
				$list.stop(true, false).slideUp();
				$group.removeClass('is-open');
				$btn.attr('aria-expanded', 'false');
			} else {
				$list.stop(true, false).slideDown();
				$group.addClass('is-open');
				$btn.attr('aria-expanded', 'true');
			}
		});
	});
}
